export const rectangleStyle = {
  left: 0,
  top: 30,
  width: 99,
  height: 30,
  unit: "%",
};

export const resolution = {
  width: 640,
  height: 480,
};

//Tesseract V1
const TESSERACT_CONFIG = {
  lang: "OCRB",
  load_system_dawg: "F",
  load_freq_dawg: "F",
  load_unambig_dawg: "F",
  load_punc_dawg: "F",
  load_number_dawg: "F",
  load_fixed_length_dawgs: "F",
  load_bigram_dawg: "F",
  wordrec_enable_assoc: "F",
  tessedit_pageseg_mode: "6",
  tessedit_char_whitelist: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789<",
};

export const recognize = async (image: HTMLCanvasElement) => {
  let Tesseract = require("tesseract.js");
  let text = "";
  await Tesseract.recognize(image, TESSERACT_CONFIG)
    .progress((message: any) => {
      // Progress HERE
    })
    .then((result: any) => {
      text = result.text;
    })
    .catch(() => {
      loadResources();
    });
  return text;
};

const addResource = (db: any) => {
  fetch("/OCRB.traineddata")
    .then((response) => response.body)
    .then((data) => {
      if (data) {
        const reader = data.getReader();
        reader.read().then(({ done, value }) => {
          if (value) {
            let customerObjectStore = db
              .transaction("./tessdata2", "readwrite")
              .objectStore("./tessdata2");
            customerObjectStore.add(value, "OCRB");
          }
        });
      }
    });
};

const refreshResource = (db: any) => {
  let transaction = db?.transaction("./tessdata2", "readwrite");
  let objectStore = transaction.objectStore("./tessdata2");
  let request = objectStore.delete("OCRB");
  request.onsuccess = (event: any) => {
    addResource(db);
  };
};

export const loadResources = () => {
  if (window.indexedDB) {
    let req = window.indexedDB.open("IDBWrapper-./tessdata2", 1);
    req.onupgradeneeded = (event: any) => {
      if (event.target) {
        let dbReq = event.target.result;
        let objectStore = dbReq.createObjectStore("./tessdata2");
        objectStore.transaction.oncomplete = (event: any) => {
          addResource(dbReq);
        };
      }
    };
    req.onsuccess = (event: any) => {
      if (event.target) {
        let db = req.result;
        let transaction = db?.transaction("./tessdata2");
        let objectStore = transaction.objectStore("./tessdata2");
        let request = objectStore.get("OCRB");
        request.onsuccess = (event: any) => {
          if (!request.result) addResource(db);
          else {
            if (request.result.length < 338000) refreshResource(db);
          }
        };
      }
    };
  }
};
